import { AppScreenModes } from '$tablet-app/src/app/app_library/types';
import { useReducer } from 'react';
import { AppSelectionStateAction as Action } from './actions';
import { AppSelectionScreenState as State } from './state';

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'switch_mode':
      return { ...state, ...action.payload };
    case 'set_search_text':
      return { ...state, ...action.payload };
    case 'toggle_category_filter': {
      const { category } = action.payload;
      let category_filters = [...state.category_filters];

      if (!category) {
        category_filters = [];
      } else if (state.category_filters.includes(category)) {
        category_filters = category_filters.filter((cat) => cat !== category);
      } else {
        category_filters = [...category_filters, category];
      }

      return { ...state, category_filters };
    }
    case 'toggle_request_app_dialog':
      return {
        ...state,
        suggest_app_dialog_visible: !state.suggest_app_dialog_visible,
      };

    default:
      return state;
  }
};

const default_state: State = {
  mode: AppScreenModes.MY_APPS,
  search_text: '',
  category_filters: [],
  /** Dialog isn't visible by default */
  suggest_app_dialog_visible: false,
};

export const useAppSelectionScreenReducer = () =>
  useReducer(reducer, default_state);
